<template>
  <ul class="v1-providers__list">
    <li v-for="item in items" :key="item.key" :class="{ 'v1-providers__item--dimmed': item.dimmed }">
      <ListItem
        :title="item.title"
        :subtitle="item.subtitle || undefined"
        :selected="selectedKey === item.key"
        :data-testid="item.testId"
        @click="$emit('select', item.key)"
      >
        <template #leading>
          <span class="v1-providers__logo">
            <img :src="item.logoUrl" :alt="item.title" />
          </span>
        </template>
        <template #trailing>
          <span class="v1-radio" :class="{ 'v1-radio--on': selectedKey === item.key }" aria-hidden="true" />
        </template>
      </ListItem>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { ListItem } from "@payjoy/design-system";

export interface ProviderCardItem {
  key: string;
  title: string;
  subtitle?: string;
  logoUrl: string;
  dimmed: boolean;
  testId: string;
}

export default defineComponent({
  name: "ProviderCardList",
  components: { ListItem },
  props: {
    items: { type: Array as PropType<ProviderCardItem[]>, default: () => [] },
    selectedKey: { type: String as PropType<string | null>, default: null },
  },
  emits: ["select"],
});
</script>

<style scoped>
.v1-providers__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.v1-providers__item--dimmed {
  opacity: 0.5;
  cursor: default !important;
}

.v1-providers__item--dimmed :deep(*) {
  cursor: default !important;
}

.v1-providers__logo {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: var(--pj-radius-md, 8px);
  overflow: hidden;
}

.v1-providers__logo img {
  max-width: 100%;
  max-height: 100%;
}

.v1-radio {
  display: block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid var(--pj-color-brand-gray-350, #c6c7bf);
  background: var(--pj-color-brand-white, #ffffff);
  box-sizing: border-box;
  transition:
    border-color var(--pj-motion-duration-fast) var(--pj-motion-easing-standard),
    border-width var(--pj-motion-duration-fast) var(--pj-motion-easing-standard);
}

.v1-radio--on {
  border-color: var(--pj-color-brand-green-450, #2fad4c);
  border-width: 6px;
}
</style>
